import { render, staticRenderFns } from "./VisitChecklistCard.vue?vue&type=template&id=19008bc6&scoped=true"
import script from "./VisitChecklistCard.vue?vue&type=script&lang=js"
export * from "./VisitChecklistCard.vue?vue&type=script&lang=js"
import style0 from "./VisitChecklistCard.vue?vue&type=style&index=0&id=19008bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19008bc6",
  null
  
)

export default component.exports